import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';

import { I18nModule } from '@recruitee/i18n';

import { DialogHeaderModule } from '../../dialog/dialog-header/dialog-header.module';
import { PipesModule } from '../pipes/pipes.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { AdminsSelectDialogFormComponent } from './admins-select-dialog-form.component';

@NgModule({
  imports: [
    CommonModule,
    DialogHeaderModule,
    ReactiveFormsModule,
    I18nModule,
    PipesModule,
    VirtualScrollerModule,
    TooltipModule,
    AdminsSelectDialogFormComponent,
  ],
  exports: [AdminsSelectDialogFormComponent],
})
export class AdminsSelectDialogFormModule {}

export { AdminsSelectDialogFormComponent };
